<template>
  <IconSolid
    icon="fa-chevron-down"
    class="transition-transform duration-300"
    :class="[{ 'rotate-180': isActive, 'cursor-pointer': bt }]" />
</template>

<script setup>
// Imports
import { computed } from 'vue'
// Props
const props = defineProps({
  modelValue: Boolean,
  bt: Boolean,
})
// Computed
const isActive = computed(() => props.modelValue)
</script>
